import {Component, HostListener, OnInit} from '@angular/core';
import {
    AuthService,
    BlockAbstractComponent,
    CacheService,
    PageService,
    ParserService,
    SpinnerService
} from '@gallaghercp/core-frontend';


declare var Isotope: any;

@Component({
    standalone: false,
    selector: 'core-block-card-tiles',
    templateUrl: './block-card-tiles.component.html',
})

export class BlockCardTilesComponent extends BlockAbstractComponent implements OnInit {

    loading!: boolean;
    tope: any;

    allHeadlinePages: any = [];
    headlineCategories: any = [];
    resizeTimeout: any;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
        protected cache: CacheService,
        protected spinner: SpinnerService,
    ) {
        super(
            parser,
            auth,
            pages,
        );
    }

    override ngOnInit() {
        this.loading = true;
        super.ngOnInit();
        this.getHeadlinePages();
    }

    getHeadlinePages() {
        if (this.tope) {
            this.tope.destroy();
        }
        // Get the 'Parent URL' of the blocks, usually its /headlines
        // Subscribe to the response so only init Isotopes code on resp
        this.pages.getOneThroughCache('page', this.block.data.parentURL, {
            'x-service-info': JSON.stringify({blockInteraction: true})
        }, false, {
            limit: this.block.data.maximumCardLimit || 100
        }).subscribe((headlinesPage: { children: any; }) => {
            this.allHeadlinePages = headlinesPage.children;
            // Sort all Headline Pages by Display Order!
            this.allHeadlinePages.sort((a: { displayOrder: number; }, b: { displayOrder: number; }) => a.displayOrder - b.displayOrder);
            // Check if Card Tile is only to display featured cards (ie select cards for Homepage etc)
            if (this.block.data.featuredCardsOnly) {
                // Set length of child pages displayed to the maximum card limit
                this.allHeadlinePages = this.allHeadlinePages.filter((headlinePage: { meta: { featuredCard: string; }; }) => headlinePage.meta.featuredCard === 'true');
                this.allHeadlinePages.sort((a: { meta: { featuredCardOrder: number; }; }, b: { meta: { featuredCardOrder: number; }; }) => a.meta.featuredCardOrder - b.meta.featuredCardOrder);
            }

            // Populate the Isotopes filtering
            // Loop through the children pages (card tiles)
            // and check for the meta.headlineCategory
            this.allHeadlinePages.forEach((headline: { meta: { headlineCategory: any; }; }, index: number) => {
                // If the page HAS a category set in meta
                if (headline.meta.headlineCategory) {
                    // Simplify the category
                    const category = headline.meta.headlineCategory;
                    // Look in the array to see if category is already in there
                    // If not, push it!
                    if (this.headlineCategories.indexOf(category) === -1) {
                        this.headlineCategories.push(category);
                    }
                }
                // If all the pages have loaded and categories sorted, re-initialise Isotopes to make it all pretty
                if ((index + 1) === this.allHeadlinePages.length) {
                    setTimeout(() => {
                        this.initIsotopes();
                        this.loading = false;
                    }, 1000);

                }
            });
        });
    }

    initIsotopes() {
        const grid = document.querySelector('.grid');
        this.tope = new Isotope(grid, {
                // layoutMode: 'fitRows'
            }
        );
    }

    filterArticlesAll($event: Event) {
        this.tope.arrange({filter: '*'});
        const allButtons = document.getElementsByClassName('btn-article');
        for (let i = 0; i < allButtons.length; i++) {
            allButtons[i].classList.remove('active');
        }
        const element = $event.currentTarget as HTMLElement | null;
        if (element) {
            element.classList.add('active');
        }
    }

    filterArticles(category: string) {
        this.tope.arrange({filter: '.' + category});
        const allButtons = document.getElementsByClassName('btn-article');
        for (let i = 0; i < allButtons.length; i++) {
            allButtons[i].classList.remove('active');
        }
        const element = document.getElementById(category);
        if(element) {
            element.classList.add('active');
        }
    }

    filterArticlesMobile($event: Event) {
        const value = ($event.target as HTMLSelectElement | null)?.value;
        if (value === '*') {
            this.tope.arrange({filter: '*'});
        } else if (value) {
            this.tope.arrange({filter: '.' + value});
        }
    }

    filterArticlesMobile32($event: Event) {
        const value = ($event.target as HTMLSelectElement | null)?.value;
        if (value === '*') {
            this.tope.arrange({filter: '*'});
        } else if (value) {
            this.tope.arrange({filter: '.' + value});
        }
    }


    @HostListener('window:resize')
    onWindowResize() {
        // debounce resize, wait for resize to finish before doing stuff
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout((() => {
            this.initIsotopes();
        }).bind(this), 200);
    }

}
